// extracted by mini-css-extract-plugin
module.exports = {"root":"tweet-in-reply-to_root__AT0_K"};